import { render } from "./ConsentVersionInfo.vue?vue&type=template&id=e30e41b0&ts=true"
import script from "./ConsentVersionInfo.vue?vue&type=script&lang=ts"
export * from "./ConsentVersionInfo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Consents/ConsentVersionInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e30e41b0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e30e41b0', __exports__)) {
    api.reload('e30e41b0', __exports__)
  }
  
  module.hot.accept("./ConsentVersionInfo.vue?vue&type=template&id=e30e41b0&ts=true", () => {
    api.rerender('e30e41b0', render)
  })

}


export default __exports__